import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { ICorrelationCurveChartData } from '@app/api/interfaces/chart-data/correlation-curve';
import { CorrelationCurveMockService } from '@mock/data-services/correlations-curve-mock.service';
import { CorrelationMode } from '@app/api/enums/correlation-mode.enum';
import { ICorrelationSpectrumChartData } from '@app/api/interfaces/chart-data/correlation-spectrum';
import { CorrelationSpectrumMockService } from '@mock/data-services/correlations-spectrum-mock.service';

@Injectable({
  providedIn: 'root',
})
export class CorrelationsChartDataApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly MOCK_CURVE: CorrelationCurveMockService,
    private readonly MOCK_SPECTRUM: CorrelationSpectrumMockService
  ) {}

  public getCurve(
    projectId: string,
    correlationId: string,
    correlationMode: CorrelationMode = CorrelationMode.CORRELATIONS
  ): Observable<IApiResponse<ICorrelationCurveChartData, object>> {
    if (this.MOCK_CURVE.isMockEnabled()) return this.MOCK_CURVE.get(projectId, correlationId);

    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/${correlationMode}/${correlationId}/chart-data/curve`;

    return this.httpClient.get<IApiResponse<ICorrelationCurveChartData, object>>(url, {
      withCredentials: true,
    });
  }

  public getSpectrum(
    projectId: string,
    correlationId: string,
    correlationMode: CorrelationMode = CorrelationMode.CORRELATIONS
  ): Observable<IApiResponse<ICorrelationSpectrumChartData, object>> {
    if (this.MOCK_SPECTRUM.isMockEnabled()) return this.MOCK_SPECTRUM.get(projectId, correlationId);

    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/${correlationMode}/${correlationId}/chart-data/spectrum`;

    return this.httpClient.get<IApiResponse<ICorrelationSpectrumChartData, object>>(url, {
      withCredentials: true,
    });
  }
}
